import React from "react";

import useLoader from "~/hooks/useLoader";
import InlineLoader from "~/components/InlineLoader";
// import ProgressBar from "~/components/progressBar/ProgressBar";

function Loader() {
  const { text, visible } = useLoader();

  return visible ? (
    <div className="flex fixed top-0 left-0 right-0 bottom-0 bg-black/30 z-[99999999] items-center justify-center">
      <div className="flex flex-col items-center justify-center text-center p-16 bg-slate-900 max-w-full min-w-300px rounded-4xl shadow">
        <InlineLoader vertical size="l" text={text} />
      </div>
    </div>
  ) : null;
}

export default Loader;
